<template>
  <!-- เมนูกระบวนงาน — แก้รายการเมนูที่ adminProcessMenus.js (govemTransfer) -->
  <AdminProcessNav v-bind="menu" />
</template>

<script>
import AdminProcessNav from "./AdminProcessNav.vue";
import { ADMIN_MENUS } from "./adminProcessMenus";

export default {
  name: "HRvecMovementmenu",
  components: { AdminProcessNav },
  data() {
    return { menu: ADMIN_MENUS.govemTransfer };
  }
};
</script>
